/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


import generalStore from './general/store'
import prepulseStore from './pre-pulse/store'
import pulseStore from './pulse/store'


export default new Vuex.Store({
  modules:{
    general: generalStore,
    prepulse: prepulseStore,
    pulse: pulseStore
  }
})
